import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom';
import { useBaseURL } from "../context/BaseURLContext";
import MenuComponent from "./MenuComponent";
import { getBrandLogoSvg } from '../branding/brandings';

const logoSrc = getBrandLogoSvg();

const VALIDATOR_BASE_URL = process.env.REACT_APP_VALIDATOR_BASE_URL;

export const Navbar = () => {
    const baseURL = useBaseURL();
    const { t } = useTranslation();
    const location = useLocation();
    const isRootPath = location.pathname === '/' || (baseURL.includes(VALIDATOR_BASE_URL) && location.pathname.includes('/validator'));
    const userInfo = sessionStorage.getItem('userinfo');

    return (
        <header className="basic-navbar">
            <div className="page-container">

                <nav className="nav-top">

                    <div className="nav-brand">
                        <NavLink to={useBaseURL().includes(VALIDATOR_BASE_URL) ? '/validator' : '/'} className="nav-link">
                            <img src={logoSrc} alt={t('navbar.logo')}  />
                        </NavLink>
                    </div>

                    {!isRootPath && (
                        location.pathname.startsWith('/signer') ? (
                            userInfo ? (
                                <MenuComponent />
                            ) : (
                                <NavLink to={baseURL.includes(VALIDATOR_BASE_URL) ? '/validator' : '/'} className="btn-medium btn-secondary">
                                    {t('navbar.back-button')}
                                </NavLink>
                            )
                        ) : (
                            <NavLink to={baseURL.includes(VALIDATOR_BASE_URL) ? '/validator' : '/'} className="btn-medium btn-secondary">
                                {t('navbar.back-button')}
                            </NavLink>
                        )
                    )}


                </nav>

            </div>
        </header>
    )
}